<div
  class="touareg-control-info w-100"
  [ngClass]="animType ? 'anim-' + animType : ''"
>
  <div class="wrapper">
    <div class="forklift mt-2">
      <div class="forklift-inner">
        <div class="photo">
          <img src="assets/images/forklift-nobg.png" />
        </div>
        <div class="ellipsis text-center my-1">
          <span class="state-label">{{ stateLabel }}</span>
        </div>
        <div *ngIf="message" class="text-center">
          <button
            mat-button
            (click)="onOpenMessage()"
            [title]="message.type + ' message'"
            [ngClass]="
              'message-btn message-' + (message.type ? message.type : 'info')
            "
          >
            <mat-icon class="fs">{{ message.matIcon }}</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
